import { struct } from '@solana/buffer-layout';
import { publicKey } from '@solana/buffer-layout-utils';
import { PublicKey } from '@solana/web3.js';
import { ExtensionType, getExtensionData } from '../extensionType.js';
/** Buffer layout for de/serializing a Group Pointer extension */

export var GroupMemberPointerLayout = struct([publicKey('authority'), publicKey('memberAddress')]);
export var GROUP_MEMBER_POINTER_SIZE = GroupMemberPointerLayout.span;
export function getGroupMemberPointerState(mint) {
  var extensionData = getExtensionData(ExtensionType.GroupMemberPointer, mint.tlvData);

  if (extensionData !== null) {
    var _GroupMemberPointerLa = GroupMemberPointerLayout.decode(extensionData),
        authority = _GroupMemberPointerLa.authority,
        memberAddress = _GroupMemberPointerLa.memberAddress; // Explicitly set None/Zero keys to null


    return {
      authority: authority.equals(PublicKey.default) ? null : authority,
      memberAddress: memberAddress.equals(PublicKey.default) ? null : memberAddress
    };
  } else {
    return null;
  }
}